import { Modal } from 'antd';
import { FC } from 'react';
import { CloseSvg, DeleteSvg } from 'utils/svgs';
import styles from './index.module.scss';
import { ConfirmDeleteProps } from './types';
import Buttons from '../Buttons';
import TextArea from 'antd/es/input/TextArea';

const ApproveRejectModal: FC<ConfirmDeleteProps> = (props) => {
	const {
		handleCancel,
		handleOk,
		isModalOpen,
		approveHandler,
		isLoading,
		selectedApproveData,
		approveHeading,
		type, // 'APPROVE' or 'REJECT'
		setRejectionReason,
		zIndex,
	} = props;

	const isApprove = type === 'APPROVE';

	const myButtons = [
		{
			text: 'Cancel',
			isLoading: false,
			className: 'secondary-button',
			fontSize: '1.8rem',
			minWidth: '14rem',
			minHeight: '4rem',
			isSubmit: false,
			onclick: handleCancel,
		},
		{
			text: isApprove ? 'Approve' : 'Reject',
			isLoading: isLoading,
			className: isApprove ? 'approve-button' : 'remove-button',
			fontSize: '1.8rem',
			minWidth: '14rem',
			minHeight: '4rem',
			isSubmit: true,
			onclick: () => approveHandler(type === 'APPROVE' ? 'APPROVED' : 'REJECTED'),

		},
	];

	return (
		<Modal
			title={
				<>
					<div className={styles['confirm-delete-model']}>
						<DeleteSvg />
					</div>
					<p className={styles['confirm-delete-model__title']}>
						Do you really want to {isApprove ? 'Approve' : 'Reject'}? {approveHeading}!
						<p style={{ fontSize: "14px", fontWeight: "400" }}>({selectedApproveData})</p>
					</p>
				</>
			}
			open={isModalOpen}
			zIndex={zIndex}
			onOk={handleOk}
			onCancel={handleCancel}
			centered={true}
			width={380}
			closable={false}
			closeIcon={<CloseSvg />}
			footer={[
				<div key={'wrapper'} className={styles['confirm-delete-model__button']}>
					<Buttons buttons={myButtons}></Buttons>
				</div>
			]}
		>
			{!isApprove && (
				<>
					<div className={styles['confirm-delete-model__reason-title']}>Reason for rejection !</div>
					<TextArea
						placeholder="Enter reason for rejection"
						rows={4}
						style={{ resize: 'none', padding: '10px' }}
						value={props.rejectionReason}
						onChange={(e) => setRejectionReason?.(e.target.value)}
					/>
				</>
			)}
		</Modal>
	);
};

export default ApproveRejectModal;

